import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainListFragment = { __typename?: 'Domain', name: string, description: string, domainType: Types.DomainType };

export type SpeedDialsQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type SpeedDialsQuery = { __typename?: 'Query', speedDials?: { __typename?: 'SpeedDialList', items: Array<{ __typename?: 'SpeedDial', id: number, shortNumber: string, targetNumber: string, description?: string | null } | null> } | null };

export const DomainListFragmentDoc = gql`
    fragment DomainList on Domain {
  name
  description
  domainType
}
    `;
export const SpeedDialsDocument = gql`
    query SpeedDials($userId: Int!) {
  speedDials(extensionId: $userId) {
    items {
      id
      shortNumber
      targetNumber
      description
    }
  }
}
    `;

/**
 * __useSpeedDialsQuery__
 *
 * To run a query within a React component, call `useSpeedDialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeedDialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeedDialsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSpeedDialsQuery(baseOptions: Apollo.QueryHookOptions<SpeedDialsQuery, SpeedDialsQueryVariables> & ({ variables: SpeedDialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpeedDialsQuery, SpeedDialsQueryVariables>(SpeedDialsDocument, options);
      }
export function useSpeedDialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpeedDialsQuery, SpeedDialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpeedDialsQuery, SpeedDialsQueryVariables>(SpeedDialsDocument, options);
        }
export function useSpeedDialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpeedDialsQuery, SpeedDialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpeedDialsQuery, SpeedDialsQueryVariables>(SpeedDialsDocument, options);
        }
export type SpeedDialsQueryHookResult = ReturnType<typeof useSpeedDialsQuery>;
export type SpeedDialsLazyQueryHookResult = ReturnType<typeof useSpeedDialsLazyQuery>;
export type SpeedDialsSuspenseQueryHookResult = ReturnType<typeof useSpeedDialsSuspenseQuery>;
export type SpeedDialsQueryResult = Apollo.QueryResult<SpeedDialsQuery, SpeedDialsQueryVariables>;